import React from 'react';

const DocumentFillIcon = ({ color = '#454F5B', scale = 1 }: { color?: string; scale?: number }): JSX.Element => (
  <svg width={24 * scale} height={24 * scale} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={24 * scale} height={24 * scale} transform="translate(0 0.400391)" fill="white" fillOpacity="0.01" />
    <path
      d="M14.59 2.99039C14.21 2.61039 13.7 2.40039 13.17 2.40039H6C4.9 2.40039 4 3.30039 4 4.40039V20.4004C4 21.5004 4.89 22.4004 5.99 22.4004H18C19.1 22.4004 20 21.5004 20 20.4004V9.23039C20 8.70039 19.79 8.19039 19.41 7.82039L14.59 2.99039ZM15 18.4004H9C8.45 18.4004 8 17.9504 8 17.4004C8 16.8504 8.45 16.4004 9 16.4004H15C15.55 16.4004 16 16.8504 16 17.4004C16 17.9504 15.55 18.4004 15 18.4004ZM15 14.4004H9C8.45 14.4004 8 13.9504 8 13.4004C8 12.8504 8.45 12.4004 9 12.4004H15C15.55 12.4004 16 12.8504 16 13.4004C16 13.9504 15.55 14.4004 15 14.4004ZM13 8.40039V3.90039L18.5 9.40039H14C13.45 9.40039 13 8.95039 13 8.40039Z"
      fill={color}
    />
  </svg>
);

export default DocumentFillIcon;
